import React from 'react';
import { compose } from 'ramda';
import { branch } from 'recompose';
import buildClassName from 'js/utils/classNameBuilder.util';
import style from './index.scss';

export const ErrorMessage = ({ error, classNames = {}, className = '', animate = false }) =>
    <div className={`${buildClassName(['error'], style, classNames)} ${className} ${animate ? 'slideInDown' : ''}`}>{error}</div>;

export const withManyErrors = Wrapped => props =>
    props.error.map((err, index) => <Wrapped key={index} {...props} error={err} />);

export default compose(
    branch(
        ({ error }) => error instanceof Array,
        withManyErrors
    )
)(ErrorMessage);
